import { conf } from '../fe-inv-conf'
import { makePostHogProvider } from './make-posthog-provider'
import { makeUserAnalytics } from './make-user-analytics'

export type FeatureFlags =
  | 'catalog-import'
  | 'catalog-export'
  | 'job-materials'
  | 'recurring-invoice'
  | 'partial-invoices'
  | 'datanorm-import'
  | 'user-hourly-rates'
  | 'line-items-images'
  | 'payment-reminders'
  | 'memo-rich-text'
  | 'beta-features'
  | 'country-selection'
  | 'text-positions'
  | 'new-document-dialog'

export const { UserAnalyticsProvider, useIsFeatureEnabled } = makeUserAnalytics<FeatureFlags>(
  makePostHogProvider({
    api_host:
      conf.ENV === 'local'
        ? 'https://eu.i.posthog.com'
        : `${conf.INVOICING_API_URL}/invoicing/collect`,
    ui_host: 'https://eu.posthog.com',
    defaults: '2025-05-24',
    capture_exceptions: {
      capture_unhandled_errors: false,
      capture_unhandled_rejections: false,
      capture_console_errors: false,
    },
    // disable_compression: true,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_dead_clicks: false,
    capture_heatmaps: false,
    capture_performance: false,
    disable_session_recording: true,
    disable_surveys: true,
    disable_scroll_properties: true,
    advanced_disable_toolbar_metrics: true,
    opt_out_capturing_by_default: true,
  }),
)
